import type { KennzahlWert } from "../../kern/modul";
import { useErgebnisPlanJeVorhaben } from "./daten";
import { mitVorzeichen } from "./logik";

/** Budget als Kennzahl auf der Karte und in der Liste unter /vorhaben (BAUPLAN-FLAECHEN.md, Abschnitt 4.2): Ergebnis Plan, Zusatz
 *  „Überschuss“ oder „Fehlbetrag“ wie im Reiter Budget. Ohne Posten „offen“. Sichtbar nur für Vorstand und Leitung (modul.ts), die View
 *  liefert anderen ohnehin keine Zeilen. */
export function budgetKennzahl(ergebnis: number | undefined): KennzahlWert {
  if (ergebnis === undefined) return { wert: "offen", zusatz: "noch keine Posten" };
  // Wie die Kachel im Reiter Budget: ab 0 „Überschuss“, darunter „Fehlbetrag“
  if (ergebnis < 0) return { wert: mitVorzeichen(ergebnis), zusatz: "Fehlbetrag", ton: "minus" };
  return { wert: mitVorzeichen(ergebnis), zusatz: "Überschuss", ton: ergebnis > 0 ? "plus" : null };
}

/** Hook für das Modulregister: null, solange die Summen laden */
export function useBudgetKennzahl(vorhabenId: string): KennzahlWert | null {
  const q = useErgebnisPlanJeVorhaben();
  return q.data ? budgetKennzahl(q.data.get(vorhabenId)) : null;
}
